module.exports = __webpack_public_path__ + "static/media/Creative.1d9ef159.png";